import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  Layout,
  notification,
  Skeleton,
  Table,
  Tabs,
  Typography,
} from 'antd';

import BreadcrumbContainer from '../../containers/Breadcrumb';
import CustomButton from '../../components/CustomButton';
import INTERNAL_LINKS from '../../enums/InternalLinks';

import { getAll as getAllHiringTypes } from '../../api/module/hiring_types';
import { getAll as getAllContractTypes } from '../../api/module/contract_types';

import './styles.scss';
import MESSAGES from '../../enums/Messages';
import { AjaxTable } from '../../components';
import { templateTypeTable } from '../../api/module/templates';
import { catchExceptionSRate } from '../../utils/helpers/helpers';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const breadcrumbItems = [
  {
    text: 'Plantillas',
  },
];
const { TabPane } = Tabs;

const Templates = () => {
  const [hiringType, setHiringType] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [contractTypeDataSource, setContractTypeDataSource] = useState([]);
  const [loadingDependent, setLoadingDependent] = useState(true);

  const getContractTypes = async () => {
    try {
      setLoadingDependent(true);
      const response = await getAllContractTypes();

      setContractTypeDataSource(response.data.results);
      setDataSource(
        response.data.results.filter((item) => item.tipo_contratacion === 1),
      );
      setLoadingDependent(false);
    } catch (exception) {
      setLoadingDependent(false);
      catchExceptionSRate(exception);
    }
  };

  const setTab = (key) => {
    setDataSource(
      contractTypeDataSource.filter(
        (item) => item.tipo_contratacion === parseInt(key),
      ),
    );
  };

  const getHiringTypes = async () => {
    try {
      let response = await getAllHiringTypes();

      setHiringType(response.data.results);
    } catch (exception) {
      let description;

      if (exception.response.data.errors) {
        const errors = exception.response.data.errors;
        description = errors.shift().detail;
      } else {
        description = 'No se pudieron obtener los registros.';
      }

      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: description,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    getHiringTypes();
    getContractTypes();
  }, []);

  const columnsIndependentTemplate = [
    {
      title: 'Plantilla',
      dataIndex: 'nombre_codigo',
    },
    {
      title: 'Tipo Persona',
      dataIndex: 'tipo_persona_nombre',
    },
    {
      title: 'Acciones',
      dataIndex: 'tipo_persona',
      align: 'center',
      width: 200,
      render: (t, record) => {
        return (
          <CustomButton
            type="default"
            htmlType={'button'}
            text={
              <Link to={`${INTERNAL_LINKS.TEMPLATE}/0/0/0/${t}/${record.id}`}>
                Ver plantillas
              </Link>
            }
          />
        );
      },
    },
  ];

  const columnsProcess = [
    {
      title: 'Tipo de contrato',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Persona Natural',
      dataIndex: 'tipo_persona',
      render: (_, record) => (
        <CustomButton
          type="default"
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.TEMPLATE}/${record.tipo_contratacion}/0/${record.id}/1/0`}
            >
              Ver plantillas
            </Link>
          }
        />
      ),
    },
    {
      title: 'Persona Jurídica',
      dataIndex: 'persona_juridica',
      render: (_, record) => (
        <CustomButton
          type="default"
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.TEMPLATE}/${record.tipo_contratacion}/0/${record.id}/2/0`}
            >
              Ver plantillas
            </Link>
          }
        />
      ),
    },
  ];

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Módulo de Plantillas
      </Title>
      <Card
        size={'small'}
        bordered={false}
        title={
          <Title level={3}>
            Plantillas que no dependen de un proceso de contratación
          </Title>
        }
      >
        <AjaxTable
          title="Listado de Plantillas"
          query={{ tipo_contrato__isnull: true, tipo_persona: 1 }}
          endpoint={templateTypeTable}
          columns={columnsIndependentTemplate}
        />
      </Card>
      <Card
        size={'small'}
        bordered={false}
        title={
          <Title level={3}>
            Plantillas que pertenecen de un proceso de contratación
          </Title>
        }
      >
        <Paragraph>
          A continuación, encontrará las opciones que le permitirán visualizar
          las plantillas disponibles.
          <br />
          Aquí podrá seleccionar el tipo de plantilla que aparecen en la tabla.
        </Paragraph>
        <Skeleton loading={loadingDependent} active>
          <Tabs defaultActiveKey="1" onChange={setTab} type="card">
            {hiringType &&
              hiringType.map((item) => (
                <TabPane tab={item.nombre} key={item.id}>
                  <Table
                    rowKey="id"
                    dataSource={dataSource}
                    columns={columnsProcess}
                    loading={loadingDependent}
                    title={() => (
                      <Paragraph className={'margin-5'} strong>
                        Listado de Plantillas {item.nombre}
                      </Paragraph>
                    )}
                  />
                </TabPane>
              ))}
          </Tabs>
        </Skeleton>
      </Card>
    </Content>
  );
};

export default Templates;
